__webpack_require__.p = "/uxp-photoshop-zh-cn/";